import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import {VimeoChannel} from "../../modele/social-media/vimeoModels";
import { HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";

export const VIMEO_API_KEY = 'b0c1dc999363efd716d3b593b8fca91c';
export const VIMEO_API_URL = 'https://api.vimeo.com/channels';

@Injectable({
  providedIn: 'root'
})
export class VimeoService {
    userToken="yahb1eg5ilr16hsabnu8orc7psmrke"
    log_prefix=this.constructor.name+":";

    constructor(private http: HttpClient,
        @Inject(VIMEO_API_KEY) private apiKey: string,
        @Inject(VIMEO_API_URL) private apiUrl: string,
        private logger: NGXLogger
    ) {
    }

    search(query: string): Observable <VimeoChannel[] > {

        let lp = this.log_prefix + "search:";
        const params = `query=${query}&limit=10&access_token=${this.apiKey}`;
        const queryUrl = `${this.apiUrl}?${params}`;
        return new Observable<VimeoChannel[]>((observer) => {
            // let list : VimeoChannel[] = [];
            this.http.get(queryUrl).subscribe(resp => {
                let data = resp['data'];
                observer.next(data);
            });
        });
    }

    getVimeoFeed(query: string): Observable <any[] > {
        let lp=this.log_prefix+"getVimeoFeed:";

      const params = `${query}/videos?access_token=${this.apiKey}`;
      const queryUrl = `${this.apiUrl}/${params}`;
        return new Observable<any[]>((observer)=>{
            // let list : VimeoChannel[] = [];
            this.http.get(queryUrl).subscribe(resp => {
                let data= resp['data'];
                observer.next(data);
            });
        });
    }
  }
